// extracted by mini-css-extract-plugin
export default {"root":"l9Ar_","title":"BpIbI","icon":"u1c3Z","success":"crrdI","description":"_HUJ8"};